import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import ContributionBillBatchFields from './ContributionBillBatchFields'

export const ContributionBatchCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list">
      <Grid container spacing={8}>
        <ContributionBillBatchFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default ContributionBatchCreate
